module.exports = __webpack_public_path__ + "img/126.f61a44ca.jpg";